module.exports = __webpack_public_path__ + "img/logo_feder.194c7d92.png";